module.exports = __webpack_public_path__ + "img/kna.bde74c6d.svg";